import api from "@/api";
import DifficultySettings from "@/components/setting/DifficultySettings";
export default {
  name: "DifficultySettingView",
  components: {
    DifficultySettings
  },
  data() {
    return {
      activeName: 'practice',
      practice: null,
      onclass: null
    };
  },
  methods: {
    init() {
      api.getDifficultySettings().then(ret => {
        this.practice = ret.practice;
        this.onclass = ret.onclass;
      });
    }
  },
  mounted() {
    this.init();
  }
};